import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';


export interface JcLabelProps extends JcCommonProps {
  readonly label: string;
  /** Associates this label with a control's `id`, rendering a real `<label htmlFor>`. */
  readonly htmlFor?: string;
}


export const JcLabel: React.FunctionComponent<JcLabelProps> = (props: JcLabelProps) => {

  const commonProps = JcUtils.commonProps(props, ["jc-label"]);

  if (props.htmlFor != null) {
    return <label {...commonProps} htmlFor={props.htmlFor}>
      {props.label}
    </label>;
  }

  return <span {...commonProps}>
    {props.label}
  </span>
}